import React from 'react';
import { Unity, useUnityContext } from "react-unity-webgl";
import './App.css';

function App() {
  const { unityProvider } = useUnityContext({
    loaderUrl: "UnityBuild/Build/UnityBuild.loader.js",
    dataUrl: "UnityBuild/Build/UnityBuild.data.unityweb",
    frameworkUrl: "UnityBuild/Build/UnityBuild.framework.js.unityweb",
    codeUrl: "UnityBuild/Build/UnityBuild.wasm.unityweb",
  });

  return <Unity unityProvider={unityProvider} />;
}

export default App;
